const GET_GCP_SECRET_MANAGER = "GET_GCP_SECRET_MANAGER";
const GET_GCP_SECRET_MANAGER_SUCCESS = "GET_GCP_SECRET_MANAGER_SUCCESS";
const GET_GCP_SECRET_MANAGER_ERROR = "GET_GCP_SECRET_MANAGER_ERROR";

export {
  GET_GCP_SECRET_MANAGER,
  GET_GCP_SECRET_MANAGER_SUCCESS,
  GET_GCP_SECRET_MANAGER_ERROR,
};
